import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import PrivacyPage from '@/modules/faq-tc/privacy';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/faq-tc/privacy')({
  component: RouteComponent,
});

function RouteComponent() {
  const { canAccessFaqManagement } = useAccessControl();

  return canAccessFaqManagement ? <PrivacyPage /> : <AccessDenied />;
}
